// FontAwesome 5 - https://fontawesome.com/
import "@fortawesome/fontawesome-pro/css/all.css";
import "slick-carousel/slick/slick.scss";
import "slick-carousel/slick/slick-theme.scss";
import "lightgallery/src/sass/lightgallery.scss";

import "bootstrap";
import "slick-carousel";

import "lightgallery";
import "lg-thumbnail";
import "lg-video";
import header from "./header/header";


// SETTING COOKIES FOR POP UP
$(document).ready(function(){
    showPopup();
});

function setCookie(cname, cvalue, exdays) {
    var expires = "expires=0";
    if(exdays !== 0){
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        expires = "expires="+d.toUTCString();
    }
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function showPopup() {
    var popup = getCookie("shownPopup");
    console.log(popup);
    if (popup === '') {
        $(".alert-banner-wrapper").addClass("show-alert");
        $(".alert-banner-overlay").addClass("show-overlay");
        setCookie('shownPopup',true,0);
    }
    else {
        $(".alert-banner-wrapper").removeClass("show-alert");
        $(".alert-banner-overlay").removeClass("show-overlay");
    }
}

$("#alert-toggle").click(function () {
    $(".alert-banner-wrapper").removeClass("show-alert");
    $(".alert-banner-overlay").removeClass("show-overlay");
});




$(function () {

    header();

    if (!detectIE()) {
        $(".parallax").jarallax({
            speed: 0.8
        });
    }

});

function detectIE() {
    const ua = window.navigator.userAgent,
        msie = ua.indexOf("MSIE "),
        trident = ua.indexOf("Trident/");

    if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)), 10);
    }

    if (trident > 0) {
        // IE 11 => return version number
        const rv = ua.indexOf("rv:");
        return parseInt(ua.substring(rv + 3, ua.indexOf(".", rv)), 10);
    }

    // other browser
    return false;
}


